export const getEditProject = (projectId: any, callback: (response: any) => void) => ({
    type: 'GET_EDIT_PROJECT',
    payload: {
        projectId,
        callback
    }
});



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/actions/project-actions/get-edit-project.ts